/* ============================================================
   IGS Wholesale Flipbook — catalog.js
   - Shopify Storefront API から全商品を取得（250件ずつ cursor pagination）
   - metaobject "ip_brand" から vendor_key とロゴを取得
   - 表紙 / IP扉 / 商品ページ(6商品/頁) を自動生成
   - StPageFlip で本物の3Dページめくり
   - 目次ジャンプ / 検索→該当ページジャンプ / ページ番号入力ジャンプ
   設定は section ルート要素の data-* 属性から読み込む。
   ============================================================ */
(function () {
  "use strict";

  var PER_PAGE = 6; // 商品ページあたりの商品数（3×2）

  function init(root) {
    if (!root || root.dataset.igsInit === "1") return;
    root.dataset.igsInit = "1";

    var cfg = {
      token: root.dataset.token || "",
      apiVersion: root.dataset.apiVersion || "2025-01",
      coverTitle: root.dataset.coverTitle || "WHOLESALE CATALOG",
      coverSub: root.dataset.coverSub || "Licensed Merchandise Catalog",
      coverTop: root.dataset.coverTop || "INFOLENS GEEK SHOP",
      coverDate: root.dataset.coverDate || "June 2026",
      coverOrg: root.dataset.coverOrg || "INFOLENS Co., Ltd.",
    };

    var els = {
      stage: root.querySelector("[data-igs-stage]"),
      book: root.querySelector("[data-igs-book]"),
      prev: root.querySelector("[data-igs-prev]"),
      next: root.querySelector("[data-igs-next]"),
      progress: root.querySelector("[data-igs-progress-bar]"),
      progressTrack: root.querySelector("[data-igs-progress]"),
      scrubber: root.querySelector("[data-igs-scrubber]"),
      pageLabel: root.querySelector("[data-igs-pagelabel]"),
      pageJump: root.querySelector("[data-igs-pagejump]"),
      pageJumpInput: root.querySelector("[data-igs-pagejump-input]"),
      pageJumpGo: root.querySelector("[data-igs-pagejump-go]"),
      tocBtn: root.querySelector("[data-igs-toc-btn]"),
      tocOverlay: root.querySelector("[data-igs-toc-overlay]"),
      tocList: root.querySelector("[data-igs-toc-list]"),
      tocCover: root.querySelector("[data-igs-toc-cover]"),
      search: root.querySelector("[data-igs-search]"),
      searchClear: root.querySelector("[data-igs-search-clear]"),
      searchOverlay: root.querySelector("[data-igs-search-overlay]"),
      results: root.querySelector("[data-igs-results]"),
      modal: root.querySelector("[data-igs-modal]"),
      modalImg: root.querySelector("[data-igs-modal-img]"),
      modalThumbs: root.querySelector("[data-igs-modal-thumbs]"),
      modalBadges: root.querySelector("[data-igs-modal-badges]"),
      modalIp: root.querySelector("[data-igs-modal-ip]"),
      modalName: root.querySelector("[data-igs-modal-name]"),
      modalPrice: root.querySelector("[data-igs-modal-price]"),
      modalSku: root.querySelector("[data-igs-modal-sku]"),
      modalDesc: root.querySelector("[data-igs-modal-desc]"),
      modalLink: root.querySelector("[data-igs-modal-link]"),
    };

    var state = {
      products: [],
      brands: {},        // vendor_key -> { name, logoUrl }
      pages: [],         // { type, vendor, items }
      vendorPage: {},    // vendor -> pageIndex(divider)
      productPage: {},   // productId -> pageIndex
      byId: {},          // productId -> product
      flip: null,
      total: 0,
      modalOpen: false,
    };

    /* ---------- Storefront API ---------- */
    function gql(query, variables) {
      return fetch("/api/" + cfg.apiVersion + "/graphql.json", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          "X-Shopify-Storefront-Access-Token": cfg.token,
        },
        body: JSON.stringify({ query: query, variables: variables || {} }),
      }).then(function (r) {
        return r.json();
      });
    }

    var PRODUCTS_Q =
      "query($cursor:String){products(first:250,after:$cursor){" +
      "pageInfo{hasNextPage endCursor}" +
      "edges{node{id title handle vendor availableForSale tags " +
      "descriptionHtml " +
      "priceRange{minVariantPrice{amount currencyCode}} " +
      "compareAtPriceRange{minVariantPrice{amount currencyCode}} " +
      "featuredImage{url altText} " +
      "images(first:20){edges{node{url altText}}} " +
      "variants(first:50){edges{node{sku barcode}}}}}}}";

    function fetchAllProducts() {
      var all = [];
      function page(cursor) {
        return gql(PRODUCTS_Q, { cursor: cursor }).then(function (res) {
          if (!res || res.errors || !res.data || !res.data.products) {
            throw new Error(
              res && res.errors ? JSON.stringify(res.errors) : "no data"
            );
          }
          var conn = res.data.products;
          conn.edges.forEach(function (e) {
            all.push(e.node);
          });
          if (conn.pageInfo.hasNextPage) return page(conn.pageInfo.endCursor);
          return all;
        });
      }
      return page(null);
    }

    // IPロゴ：セクションの ip_logo ブロック（JSON）から vendor → logoUrl を読む
    function loadLogos() {
      var map = {};
      var sc = root.querySelector("[data-igs-logos]");
      if (!sc) return map;
      try {
        JSON.parse(sc.textContent || "[]").forEach(function (o) {
          var v = (o.vendor || "").trim();
          if (v && o.logo) map[v] = { logoUrl: o.logo };
        });
      } catch (e) {}
      return map;
    }

    // カタログ非表示vendor（ブラックリスト）：textarea を1行1vendorで読む
    function loadExcluded() {
      var raw = root.dataset.excluded || "";
      return raw
        .split(/\r?\n/)
        .map(function (s) { return s.trim(); })
        .filter(Boolean);
    }

    /* ---------- ヘルパ ---------- */
    function yen(amount, currency) {
      var n = parseFloat(amount);
      if (isNaN(n)) return "";
      if (currency && currency !== "JPY") {
        try {
          return new Intl.NumberFormat("ja-JP", { style: "currency", currency: currency }).format(n);
        } catch (e) {}
      }
      return "¥" + Math.round(n).toLocaleString("ja-JP");
    }
    function priceTxt(p) {
      var mvp = p.priceRange && p.priceRange.minVariantPrice;
      return mvp ? yen(mvp.amount, mvp.currencyCode) : "";
    }
    // 割引前価格（compareAtPrice > price のとき取り消し線で出す金額）。なければ ""
    function compareTxt(p) {
      var mvp = p.priceRange && p.priceRange.minVariantPrice;
      var cmp = p.compareAtPriceRange && p.compareAtPriceRange.minVariantPrice;
      if (!mvp || !cmp) return "";
      var price = parseFloat(mvp.amount);
      var was = parseFloat(cmp.amount);
      if (isNaN(price) || isNaN(was) || was <= price) return "";
      return yen(cmp.amount, cmp.currencyCode);
    }
    // 卸カタログのため定価のみ表示：compareAtPrice(定価)があればそれ、なければ price
    function priceHtml(p) {
      return esc(compareTxt(p) || priceTxt(p));
    }

    // 既存テーマ snippets/product-label.liquid のタグ→ラベル→色マッピングを流用。
    // 商品タグ（小文字化して照合）と availableForSale / 割引から表示バッジを決める。
    function badgesFor(p) {
      var out = [];
      var tags = {};
      (p.tags || []).forEach(function (t) { tags[String(t).toLowerCase()] = true; });
      function has(name) { return !!tags[String(name).toLowerCase()]; }

      var isComingSoon = has("coming soon") || has("comingsoon");
      // クリスマス限定
      if (has("クリスマス限定")) out.push({ label: "クリスマス限定", bg: "#165B33", fg: "#ffffff" });
      // 予約商品
      if (has("予約")) out.push({ label: "予約商品", bg: "#B1CC19", fg: "#ffffff" });
      // SOLD OUT（Coming Soon のときは出さない）
      if (!isComingSoon && p.availableForSale === false) out.push({ label: "SOLD OUT", bg: "#555555", fg: "#ffffff" });
      // NEW（タグ）
      if (has("new")) out.push({ label: "NEW", bg: "#212b36", fg: "#ffffff" });
      // イベント系タグ
      if (has("ポイントup")) out.push({ label: "ポイントUP", bg: "#0000ff", fg: "#ffffff" });
      if (has("ブラックフライデー")) out.push({ label: "ブラックフライデー", bg: "#000000", fg: "#FFD700" });
      if (has("先行販売")) out.push({ label: "先行販売", bg: "#5383c3", fg: "#ffffff" });
      if (has("tgs2025")) out.push({ label: "TGS会場受取", bg: "#990066", fg: "#ffffff" });
      // 右側系
      if (isComingSoon) out.push({ label: "Coming Soon", bg: "#FFA500", fg: "#ffffff" });
      if (has("限定")) out.push({ label: "当店限定", bg: "#FFD700", fg: "#000000" });
      if (has("再入荷")) out.push({ label: "再入荷", bg: "#008000", fg: "#ffffff" });
      return out;
    }
    function badgeSpans(p) {
      return badgesFor(p).map(function (b) {
        return '<span class="igs-badge" style="background:' + b.bg + ';color:' + b.fg + ';">' + esc(b.label) + "</span>";
      }).join("");
    }
    function badgesHtml(p) {
      var spans = badgeSpans(p);
      return spans ? '<div class="igs-badges">' + spans + "</div>" : "";
    }
    function brandName(vendor) {
      return vendor; // 表示名は vendor をそのまま使用
    }
    function brandLogo(vendor) {
      var b = state.brands[(vendor || "").trim()];
      return b && b.logoUrl ? b.logoUrl : "";
    }
    function esc(str) {
      return String(str == null ? "" : str)
        .replace(/&/g, "&amp;").replace(/</g, "&lt;")
        .replace(/>/g, "&gt;").replace(/"/g, "&quot;");
    }
    function chunk(arr, n) {
      var out = [];
      for (var i = 0; i < arr.length; i += n) out.push(arr.slice(i, i + n));
      return out;
    }
    function skus(p) {
      var out = [];
      if (p.variants && p.variants.edges) {
        p.variants.edges.forEach(function (e) {
          if (e.node.sku) out.push(e.node.sku);
          if (e.node.barcode) out.push(e.node.barcode);
        });
      }
      return out;
    }

    /* ---------- ページ構成生成 ---------- */
    function buildPages() {
      var pages = [];
      // 1. 表紙
      pages.push({ type: "cover" });

      // 2. vendorグルーピング（表示名でソート）
      var groups = {};
      state.products.forEach(function (p) {
        var v = p.vendor || "（その他）";
        (groups[v] = groups[v] || []).push(p);
      });
      var vendors = Object.keys(groups).sort(function (a, b) {
        return brandName(a).localeCompare(brandName(b), "ja");
      });

      vendors.forEach(function (v) {
        // IP扉
        pages.push({ type: "divider", vendor: v });
        // 商品ページ（6商品ずつ）
        var items = groups[v].slice().sort(function (a, b) {
          return (a.title || "").localeCompare(b.title || "", "ja");
        });
        chunk(items, PER_PAGE).forEach(function (group) {
          pages.push({ type: "products", vendor: v, items: group });
        });
      });

      // 裏表紙（見開きを整える）
      pages.push({ type: "back" });

      state.pages = pages;
      // インデックス・マップ
      state.vendorPage = {};
      state.productPage = {};
      pages.forEach(function (pg, idx) {
        if (pg.type === "divider" && state.vendorPage[pg.vendor] === undefined) {
          state.vendorPage[pg.vendor] = idx;
        }
        if (pg.type === "products") {
          pg.items.forEach(function (it) {
            if (state.productPage[it.id] === undefined) state.productPage[it.id] = idx;
          });
        }
      });
      return { vendors: vendors, groups: groups };
    }

    /* ---------- ページDOM ---------- */
    function pageEl(pg) {
      var div = document.createElement("div");
      div.className = "igs-page";
      if (pg.type === "cover" || pg.type === "back") div.setAttribute("data-density", "hard");

      var inner;
      if (pg.type === "cover") {
        var titleHtml = esc(cfg.coverTitle);
        if (/&lt;br\s*\/?&gt;/i.test(titleHtml)) {
          titleHtml = titleHtml.replace(/&lt;br\s*\/?&gt;/gi, "<br>");
        } else {
          titleHtml = titleHtml.replace(/\s+/, "<br>");
        }
        inner =
          '<div class="igs-page-inner igs-cover">' +
          '<div class="igs-cover-top">' + esc(cfg.coverTop) + "</div>" +
          '<div class="igs-cover-mid">' +
          '<h1 class="igs-cover-title">' + titleHtml + "</h1>" +
          '<div class="igs-cover-sub">' + esc(cfg.coverSub) + "</div>" +
          "</div>" +
          '<div class="igs-cover-foot"><span>' + esc(cfg.coverDate) +
          "</span><span>" + esc(cfg.coverOrg) + "</span></div>" +
          "</div>";
      } else if (pg.type === "divider") {
        var logo = brandLogo(pg.vendor);
        var logoHtml = logo
          ? '<img src="' + esc(logo) + '" alt="' + esc(brandName(pg.vendor)) + '">'
          : '<span class="igs-prod-ph">' + esc(brandName(pg.vendor)) + "</span>";
        inner =
          '<div class="igs-page-inner igs-divider">' +
          '<div class="igs-divider-logo">' + logoHtml + "</div>" +
          '<div class="igs-divider-ip">' + esc(brandName(pg.vendor)) + "</div>" +
          '<div class="igs-divider-col">' + esc(brandName(pg.vendor)) + " Collection</div>" +
          "</div>";
      } else if (pg.type === "products") {
        var cards = pg.items
          .map(function (it) {
            var img =
              it.featuredImage && it.featuredImage.url
                ? '<img src="' + esc(it.featuredImage.url) + '" alt="' + esc(it.featuredImage.altText || it.title) + '" loading="lazy">'
                : '<span class="igs-prod-ph">no image</span>';
            return (
              '<div class="igs-prod" data-igs-prod-id="' + esc(it.id) + '">' +
              '<div class="igs-prod-thumb">' + badgesHtml(it) + img + "</div>" +
              '<div class="igs-prod-ip">' + esc(brandName(it.vendor)) + "</div>" +
              '<div class="igs-prod-name">' + esc(it.title) + "</div>" +
              '<div class="igs-prod-price">' + priceHtml(it) + "</div>" +
              "</div>"
            );
          })
          .join("");
        inner =
          '<div class="igs-page-inner">' +
          '<div class="igs-prodpage-head">' + esc(brandName(pg.vendor)) + "</div>" +
          '<div class="igs-prodgrid">' + cards + "</div>" +
          "</div>";
      } else {
        inner =
          '<div class="igs-page-inner igs-back">' +
          '<div class="igs-back-text">© ' + esc(cfg.coverOrg) + " All rights reserved.</div>" +
          "</div>";
      }
      div.innerHTML = inner;
      return div;
    }

    function renderBook() {
      els.book.innerHTML = "";
      state.pages.forEach(function (pg) {
        els.book.appendChild(pageEl(pg));
      });
    }

    /* ---------- StPageFlip ---------- */
    // StPageFlip設定。重さの根本原因だった size:"stretch"（ライブラリが独自に
    // resizeを監視し、スマホのURLバー開閉で連続再描画→重くなる）をスマホでは使わず、
    // 初期化時に一度だけ算出した固定サイズ size:"fixed" を渡す。PCは従来どおり stretch。
    function flipOptions() {
      var opts = {
        maxShadowOpacity: 0.25,
        showCover: true,
        usePortrait: true,
        mobileScrollSupport: false,
        swipeDistance: 20,          // 戻る/進むスワイプを左右対称に認識しやすくする
        flippingTime: 700,
        drawShadow: true,
        clickEventForward: false,   // 子要素(リンク等)クリックをめくりに転送しない
        disableFlipByClick: true,   // クリックでめくらない（カードのモーダル表示と競合させない）
      };
      var isMobile = window.matchMedia("(max-width:768px)").matches;
      if (!isMobile) {
        // PC：既知の動作する設定（変更しない）
        opts.size = "stretch";
        opts.width = 460; opts.height = 650;
        opts.minWidth = 280; opts.maxWidth = 600;
        opts.minHeight = 380; opts.maxHeight = 850;
        return opts;
      }
      // スマホ：固定サイズ。左右ガター(48px×2=96)を差し引いた幅。0/NaN/負値ガード。
      var vw = window.innerWidth || document.documentElement.clientWidth || 360;
      if (!isFinite(vw) || vw <= 0) vw = 360;
      var w = Math.floor(vw - 96);
      if (!isFinite(w) || w < 220) w = 220;
      var h = Math.round(w * 1.41); // 元の縦横比 650/460
      if (!isFinite(h) || h < 360) h = 360;
      opts.size = "fixed";
      opts.width = w; opts.height = h;
      return opts;
    }

    function initFlip() {
      if (!window.St || !window.St.PageFlip) {
        showState("フリップビューの読み込みに失敗しました（StPageFlip）。");
        return;
      }
      var pf = new window.St.PageFlip(els.book, flipOptions());
      pf.loadFromHTML(els.book.querySelectorAll(".igs-page"));
      state.flip = pf;
      state.total = pf.getPageCount();

      pf.on("flip", updateNav);
      pf.on("changeState", updateNav);
      pf.on("init", updateNav);
      updateNav();
    }

    // リサイズ/画面回転時にフリップを実寸へ再計算（不具合2）。現在ページを保持して再構築。
    function refitFlip() {
      if (!state.flip || !state.pages || !state.pages.length) return;
      var idx = currentIndex();
      try { state.flip.destroy(); } catch (e) {}
      state.flip = null;
      renderBook();
      initFlip();
      if (idx > 0 && state.flip) {
        try {
          if (typeof state.flip.turnToPage === "function") state.flip.turnToPage(idx);
          else state.flip.flip(idx);
        } catch (e) {}
        updateNav();
      }
    }

    function currentIndex() {
      return state.flip ? state.flip.getCurrentPageIndex() : 0;
    }

    function gotoPage(idx) {
      if (!state.flip) return;
      var max = state.total - 1;
      var t = Math.max(0, Math.min(max, idx));
      state.flip.flip(t);
    }

    function isMobileView() {
      return window.matchMedia("(max-width:768px)").matches;
    }

    // 進む：StPageFlip ネイティブの flipNext（PC/スマホ両方で動作・アニメ付き）。
    function navNext() {
      if (!state.flip) return;
      try { state.flip.flipNext(); } catch (x) {}
    }

    // 戻る：スマホ（portrait + size:fixed）では StPageFlip の点ベース flipPrev が
    // 無反応になるため、ゲート無し・点計算無しの turnToPage で確実に1ページ戻す。
    // PC（landscape）では flipPrev が正常動作するのでそのまま使う。
    function navPrev() {
      if (!state.flip) return;
      if (isMobileView()) {
        var idx = state.flip.getCurrentPageIndex();
        if (idx <= 0) return;
        try {
          if (typeof state.flip.turnToPage === "function") state.flip.turnToPage(idx - 1);
          else state.flip.flip(idx - 1);
        } catch (x) {}
        updateNav();
      } else {
        try { state.flip.flipPrev(); } catch (x) {}
      }
    }

    function updateNav() {
      var idx = currentIndex();
      var total = state.total || 1;
      if (els.pageLabel) els.pageLabel.textContent = idx + 1 + " / " + total;
      if (els.progress) els.progress.style.width = ((idx + 1) / total) * 100 + "%";
      if (els.prev) els.prev.disabled = idx <= 0;
      if (els.next) els.next.disabled = idx >= total - 1;
    }

    function showState(msg) {
      els.book.innerHTML = '<div class="igs-state">' + esc(msg) + "</div>";
    }

    // 指定ページのラベル（スクラバー用）。表紙/裏表紙/IP名
    function pageLabelFor(idx) {
      var pg = state.pages[idx];
      if (!pg) return "";
      if (pg.type === "cover") return "表紙";
      if (pg.type === "back") return "裏表紙";
      return brandName(pg.vendor);
    }

    // テーマのグローバルヘッダーと食い込まないよう sticky 位置を補正（point 3）
    function syncHeaderOffset() {
      var bar = root.querySelector(".igs-topbar");
      if (!bar) return;
      var sel = [
        "#shopify-section-header", "#shopify-section-sections--header",
        ".shopify-section-group-header-group", "sticky-header",
        "header.header", ".section-header",
      ];
      var hdr = null;
      for (var i = 0; i < sel.length; i++) {
        var el = document.querySelector(sel[i]);
        if (el && el.offsetHeight) { hdr = el; break; }
      }
      var top = 0;
      if (hdr) {
        var pos = getComputedStyle(hdr).position;
        if (pos === "sticky" || pos === "fixed") top = hdr.getBoundingClientRect().height;
      }
      bar.style.top = top + "px";
    }

    /* ---------- 目次 ---------- */
    function renderToc(vendors, groups) {
      var html = vendors
        .map(function (v) {
          var logo = brandLogo(v);
          var logoHtml = logo
            ? '<span class="igs-toc-logo"><img src="' + esc(logo) + '" alt=""></span>'
            : '<span class="igs-toc-logo"></span>';
          return (
            '<button type="button" class="igs-toc-item" data-igs-jump-vendor="' + esc(v) + '">' +
            logoHtml +
            "<span>" + esc(brandName(v)) + "</span>" +
            '<span class="igs-toc-count">' + groups[v].length + "点</span>" +
            "</button>"
          );
        })
        .join("");
      els.tocList.innerHTML = html;
    }

    function openOverlay(ov) { ov.classList.add("is-on"); }
    function closeOverlay(ov) { ov.classList.remove("is-on"); }

    /* ---------- 検索 ---------- */
    function runSearch(q) {
      q = (q || "").trim().toLowerCase();
      if (!q) {
        closeOverlay(els.searchOverlay);
        els.searchClear.classList.remove("is-on");
        return;
      }
      els.searchClear.classList.add("is-on");
      var hits = state.products.filter(function (p) {
        var hay =
          (p.title || "") + " " + brandName(p.vendor) + " " + (p.vendor || "") + " " + skus(p).join(" ");
        return hay.toLowerCase().indexOf(q) !== -1;
      });
      renderResults(hits);
      openOverlay(els.searchOverlay);
    }

    function renderResults(hits) {
      if (!hits.length) {
        els.results.innerHTML = '<div class="igs-results-empty">該当する商品がありません。</div>';
        return;
      }
      els.results.innerHTML = hits
        .slice(0, 60)
        .map(function (p) {
          var img =
            p.featuredImage && p.featuredImage.url
              ? '<img src="' + esc(p.featuredImage.url) + '" alt="' + esc(p.title) + '" loading="lazy">'
              : '<span class="igs-prod-ph">no image</span>';
          return (
            '<button type="button" class="igs-result" data-igs-jump-product="' + esc(p.id) + '">' +
            '<span class="igs-result-thumb">' + img + "</span>" +
            '<span class="igs-result-ip">' + esc(brandName(p.vendor)) + "</span>" +
            '<span class="igs-result-name">' + esc(p.title) + "</span>" +
            '<span class="igs-result-price">' + esc(priceTxt(p)) + "</span>" +
            "</button>"
          );
        })
        .join("");
    }

    function clearSearch() {
      els.search.value = "";
      els.searchClear.classList.remove("is-on");
      closeOverlay(els.searchOverlay);
    }

    /* ---------- ページ番号入力 ---------- */
    function openPageJump() {
      els.pageLabel.style.display = "none";
      els.pageJump.classList.add("is-on");
      els.pageJumpInput.value = currentIndex() + 1;
      els.pageJumpInput.focus();
      els.pageJumpInput.select();
    }
    function closePageJump() {
      els.pageJump.classList.remove("is-on");
      els.pageLabel.style.display = "";
    }
    function commitPageJump() {
      var n = parseInt(els.pageJumpInput.value, 10);
      if (!isNaN(n)) gotoPage(n - 1); // 範囲外は gotoPage 内でクランプ
      closePageJump();
    }

    /* ---------- スクロール式ページ選択（プログレスバードラッグ） ---------- */
    function setupScrubber() {
      var track = els.progressTrack;
      if (!track || !els.scrubber) return;
      var dragging = false;

      function clientX(e) {
        if (e.clientX != null) return e.clientX;
        if (e.touches && e.touches[0]) return e.touches[0].clientX;
        return 0;
      }
      function idxFromEvent(e) {
        var rect = track.getBoundingClientRect();
        var frac = rect.width ? (clientX(e) - rect.left) / rect.width : 0;
        frac = Math.max(0, Math.min(1, frac));
        var total = state.total || 1;
        return Math.round(frac * (total - 1));
      }
      function showScrubber(idx) {
        var rect = track.getBoundingClientRect();
        var total = state.total || 1;
        var left = total <= 1 ? 0 : (idx / (total - 1)) * rect.width;
        els.scrubber.style.left = left + "px";
        els.scrubber.innerHTML =
          '<span class="igs-scrubber-pg">' + (idx + 1) + " / " + total + "</span>" +
          '<span class="igs-scrubber-ip">' + esc(pageLabelFor(idx)) + "</span>";
        els.scrubber.classList.add("is-on");
        // ドラッグ中はバーをプレビュー（transition なしで即追従）
        if (els.progress) {
          els.progress.style.transition = "none";
          els.progress.style.width = ((idx + 1) / total) * 100 + "%";
        }
      }
      function onDown(e) {
        if (!state.flip) return;
        dragging = true;
        showScrubber(idxFromEvent(e));
        e.preventDefault();
      }
      function onMove(e) {
        if (!dragging) return;
        showScrubber(idxFromEvent(e));
      }
      function onUp(e) {
        if (!dragging) return;
        dragging = false;
        var idx = idxFromEvent(e);
        els.scrubber.classList.remove("is-on");
        if (els.progress) els.progress.style.transition = "";
        gotoPage(idx);
        updateNav();
      }
      track.addEventListener("pointerdown", onDown);
      document.addEventListener("pointermove", onMove);
      document.addEventListener("pointerup", onUp);
    }

    /* ---------- 商品詳細モーダル ---------- */
    // 商品の全画像（images）。なければ featuredImage、それも無ければ空配列
    function productImages(p) {
      var out = [];
      if (p.images && p.images.edges) {
        p.images.edges.forEach(function (e) {
          if (e.node && e.node.url) out.push({ url: e.node.url, altText: e.node.altText || "" });
        });
      }
      if (!out.length && p.featuredImage && p.featuredImage.url) {
        out.push({ url: p.featuredImage.url, altText: p.featuredImage.altText || "" });
      }
      return out;
    }
    function setMainImage(img, title) {
      if (!els.modalImg) return;
      if (img && img.url) {
        els.modalImg.src = img.url;
        els.modalImg.alt = img.altText || title || "";
        els.modalImg.style.display = "";
      } else {
        els.modalImg.removeAttribute("src");
        els.modalImg.style.display = "none";
      }
    }
    function renderGallery(p) {
      var imgs = productImages(p);
      setMainImage(imgs[0], p.title);
      if (!els.modalThumbs) return;
      if (imgs.length <= 1) {
        els.modalThumbs.innerHTML = "";
        els.modalThumbs.style.display = "none";
        return;
      }
      els.modalThumbs.style.display = "";
      els.modalThumbs.innerHTML = imgs
        .map(function (im, i) {
          return (
            '<button type="button" class="igs-modal-thumb' + (i === 0 ? " is-on" : "") + '" ' +
            'data-igs-thumb-idx="' + i + '" data-url="' + esc(im.url) + '" ' +
            'data-alt="' + esc(im.altText || p.title || "") + '">' +
            '<img src="' + esc(im.url) + '" alt="" loading="lazy">' +
            "</button>"
          );
        })
        .join("");
    }

    function openModal(id) {
      var p = state.byId[id];
      if (!p || !els.modal) return;
      renderGallery(p);
      if (els.modalBadges) els.modalBadges.innerHTML = badgeSpans(p);
      if (els.modalIp) els.modalIp.textContent = brandName(p.vendor);
      if (els.modalName) els.modalName.textContent = p.title || "";
      if (els.modalPrice) els.modalPrice.innerHTML = priceHtml(p);
      if (els.modalSku) {
        var codes = skus(p);
        if (codes.length) {
          els.modalSku.textContent = "SKU/JAN: " + codes.join(" / ");
          els.modalSku.style.display = "";
        } else {
          els.modalSku.textContent = "";
          els.modalSku.style.display = "none";
        }
      }
      if (els.modalDesc) {
        var html = p.descriptionHtml || "";
        if (html && html.trim()) {
          els.modalDesc.innerHTML = html;
          els.modalDesc.style.display = "";
        } else {
          els.modalDesc.innerHTML = "";
          els.modalDesc.style.display = "none";
        }
      }
      if (els.modalLink && p.handle) {
        els.modalLink.href = "/products/" + p.handle;
      }
      els.modal.classList.add("is-on");
      state.modalOpen = true;
      // 開いた瞬間は常に本文先頭から表示（前回のスクロール位置を引き継がない）。
      var modalBody = els.modal.querySelector(".igs-modal-body");
      if (modalBody) modalBody.scrollTop = 0;
    }
    function closeModal() {
      if (!els.modal) return;
      els.modal.classList.remove("is-on");
      state.modalOpen = false;
    }

    /* ---------- イベント ---------- */
    if (els.prev) els.prev.addEventListener("click", navPrev);
    if (els.next) els.next.addEventListener("click", navNext);

    // 商品カードのタップ/クリック判定（StPageFlipのめくり=ドラッグと分離）
    if (els.book) {
      var TAP_MOVE = 10;   // px。これ未満の移動はクリック、超えたらめくり扱い
      var SWIPE_BACK = 50; // px。右方向へこれ以上動いたら「戻る」スワイプ
      var down = null;     // { x, y, card }
      els.book.addEventListener("pointerdown", function (e) {
        var card = e.target.closest ? e.target.closest("[data-igs-prod-id]") : null;
        down = { x: e.clientX, y: e.clientY, card: card };
      }, true);
      els.book.addEventListener("pointerup", function (e) {
        if (!down) return;
        var dx = e.clientX - down.x;
        var dy = e.clientY - down.y;
        var moved = Math.sqrt(dx * dx + dy * dy);
        var card = down.card;
        down = null;
        if (moved >= TAP_MOVE) {
          // めくり操作。スマホでは右スワイプ（戻る）が StPageFlip で無反応のため自前で戻す。
          // 左スワイプ（進む）はネイティブが処理するので触らない（二重送り防止）。
          if (isMobileView() && dx > SWIPE_BACK && Math.abs(dx) > Math.abs(dy)) navPrev();
          return;
        }
        if (!card) return;
        var id = card.getAttribute("data-igs-prod-id");
        if (id) openModal(id);
      }, true);
    }

    if (els.tocBtn) els.tocBtn.addEventListener("click", function () { openOverlay(els.tocOverlay); });
    if (els.tocCover) els.tocCover.addEventListener("click", function () { closeOverlay(els.tocOverlay); gotoPage(0); });
    if (els.tocList)
      els.tocList.addEventListener("click", function (e) {
        var btn = e.target.closest("[data-igs-jump-vendor]");
        if (!btn) return;
        var v = btn.getAttribute("data-igs-jump-vendor");
        closeOverlay(els.tocOverlay);
        if (state.vendorPage[v] !== undefined) gotoPage(state.vendorPage[v]);
      });

    if (els.results)
      els.results.addEventListener("click", function (e) {
        var btn = e.target.closest("[data-igs-jump-product]");
        if (!btn) return;
        var id = btn.getAttribute("data-igs-jump-product");
        clearSearch();
        if (state.productPage[id] !== undefined) gotoPage(state.productPage[id]);
      });

    if (els.search) {
      var t;
      els.search.addEventListener("input", function () {
        clearTimeout(t);
        var v = els.search.value;
        t = setTimeout(function () { runSearch(v); }, 180);
      });
    }
    if (els.searchClear) els.searchClear.addEventListener("click", clearSearch);

    // ×ボタンは自分が属するオーバーレイを閉じる
    [].forEach.call(root.querySelectorAll("[data-igs-overlay-close]"), function (b) {
      b.addEventListener("click", function () {
        var ov = b.closest(".igs-overlay");
        if (ov) closeOverlay(ov);
      });
    });
    // 背景クリックで閉じる
    [els.tocOverlay, els.searchOverlay].forEach(function (ov) {
      if (!ov) return;
      ov.addEventListener("click", function (e) {
        if (e.target === ov) closeOverlay(ov);
      });
    });

    setupScrubber();
    syncHeaderOffset();
    window.addEventListener("resize", syncHeaderOffset);
    window.addEventListener("load", syncHeaderOffset);

    // リサイズ/回転でフリップ寸法を再計算（デバウンス）。
    // スマホのURLバー開閉は「高さのみ」変化するので無視し、幅が変わった時だけ再構築。
    var refitTimer = null;
    var lastW = window.innerWidth;
    function scheduleRefit(delay) {
      clearTimeout(refitTimer);
      refitTimer = setTimeout(refitFlip, delay);
    }
    window.addEventListener("resize", function () {
      var w = window.innerWidth;
      if (Math.abs(w - lastW) < 40) return; // 高さのみの変化は無視
      lastW = w;
      scheduleRefit(250);
    });
    window.addEventListener("orientationchange", function () {
      lastW = window.innerWidth;
      scheduleRefit(350);
    });

    if (els.pageLabel) els.pageLabel.addEventListener("click", openPageJump);
    if (els.pageJumpGo) els.pageJumpGo.addEventListener("click", commitPageJump);
    if (els.pageJumpInput)
      els.pageJumpInput.addEventListener("keydown", function (e) {
        if (e.key === "Enter") commitPageJump();
        else if (e.key === "Escape") closePageJump();
      });

    // モーダル：×ボタン・背景クリックで閉じる
    if (els.modal) {
      [].forEach.call(els.modal.querySelectorAll("[data-igs-modal-close]"), function (b) {
        b.addEventListener("click", closeModal);
      });
      els.modal.addEventListener("click", function (e) {
        if (e.target === els.modal) closeModal();
      });
    }
    // モーダル：サムネイルクリックでメイン画像を切り替え
    if (els.modalThumbs) {
      els.modalThumbs.addEventListener("click", function (e) {
        var btn = e.target.closest("[data-igs-thumb-idx]");
        if (!btn) return;
        setMainImage({ url: btn.getAttribute("data-url"), altText: btn.getAttribute("data-alt") }, "");
        [].forEach.call(els.modalThumbs.querySelectorAll(".igs-modal-thumb"), function (t) {
          t.classList.toggle("is-on", t === btn);
        });
      });
    }

    document.addEventListener("keydown", function (e) {
      if (e.key === "Escape" && state.modalOpen) { closeModal(); return; }
      if (state.modalOpen) return; // モーダル表示中はめくり操作を無効化
      if (!state.flip) return;
      if (document.activeElement === els.search || document.activeElement === els.pageJumpInput) return;
      if (e.key === "ArrowLeft") state.flip.flipPrev();
      else if (e.key === "ArrowRight") state.flip.flipNext();
    });

    /* ---------- 起動 ---------- */
    if (!cfg.token) {
      showState("Storefront APIアクセストークンが設定されていません。\nテーマエディタでセクション設定にトークンを入力してください。");
      return;
    }
    showState("読み込み中…");

    // ロゴ・除外設定はセクション設定（同期）から読み込む
    state.brands = loadLogos();
    var excluded = loadExcluded();

    fetchAllProducts()
      .then(function (products) {
        state.products = products || [];
        // カタログ非表示vendorを除外（vendor名の完全一致・前後空白trim）
        if (excluded.length) {
          state.products = state.products.filter(function (p) {
            return excluded.indexOf((p.vendor || "").trim()) === -1;
          });
        }
        if (!state.products.length) {
          showState("商品が見つかりませんでした。");
          return;
        }
        state.byId = {};
        state.products.forEach(function (p) { state.byId[p.id] = p; });
        var built = buildPages();
        renderBook();
        renderToc(built.vendors, built.groups);
        initFlip();
      })
      .catch(function (err) {
        showState("商品の読み込みに失敗しました。トークンとAPIバージョンをご確認ください。");
        if (window.console) console.error("[catalog]", err);
      });
  }

  function boot() {
    var roots = document.querySelectorAll("[data-igs-root]");
    [].forEach.call(roots, init);
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", boot);
  } else {
    boot();
  }
})();
